<template>
  <div>
    <b-form-group>
      <template #label>
        <strong>{{title}}</strong>
        <b-form-checkbox
          v-model="allSelectedLocal"
          :indeterminate="indeterminate"
          @change="toggleAll"
        >
          {{ allSelectedLocal ? parentTitleAllSelected : parentTitle }}
        </b-form-checkbox>
      </template>

      <template v-slot="{ ariaDescribedby }">
        <b-form-checkbox-group
          v-model="selected"
          :options="childOptions"
          class="ml-4"
          stacked
        ></b-form-checkbox-group>
      </template>
    </b-form-group>
  </div>
</template>

<script>
  export default {
    props: {
      title: {
        type: String,
        default: null
      },
      parentTitle: {
        type: String,
        default: 'Select All'
      },
      parentTitleAllSelected: {
        type: String,
        default: 'Un-select All'
      },
      childOptions: {
        type: Array,
        default: () => [],
        required: true
      },
      allSelected: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        selected: [],
        allSelectedLocal: false,
        childOptionsLocal: [],
        indeterminate: false
      }
    },
    watch: {
      selected(newValue, oldValue) {
        if (newValue.length === 0) {
          this.indeterminate = false
          this.allSelectedLocal = false
        } else if (newValue.length === this.childOptionsLocal.length) {
          this.indeterminate = false
          this.allSelectedLocal = true
        } else {
          this.indeterminate = true
          this.allSelectedLocal = false
        }
        console.log(newValue)
        this.$emit('input', newValue)
      }
    },
    mounted () {
      this.childOptionsLocal = [...new Set(this.childOptions)]
      if (this.allSelected) {
        this.toggleAll(true)
      }
    },
    methods: {
      toggleAll(checked) {
        this.selected = checked ? this.childOptionsLocal.map(x => x.value).slice() : []
      }
    }
  }
</script>